export default __webpack_public_path__ + "static/media/profile.0e4b7c6b.svg";